<template>
    <div class="allPage">
        <new-header></new-header>
        <div class="VocContent">
            <router-view/>
        </div>
    </div>
</template>

<script>
    import NewHeader from "../../components/newHeader/header";

    export default {
        name: "index",
        components: {NewHeader}
    }
</script>

<style scoped lang="less">
    .allPage {
        display: flex;
        flex-direction: column;
        height: 100%;
        overflow: auto;
        .VocContent {
            flex: 1;
            overflow: auto;
        }
    }
</style>